import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  Modal, 
  TextField, 
  Typography
} from '@mui/material';

import useSelectedTenant from '../../../../../components/hooks/useSelectedTenant';
import LoadingButton from '../../../../../components/buttons/Button';

import { 
  CreateBankBIZcore, 
  GetBanksBIZcore, 
  UpdateBankBIZcore 
} from '../../../../../redux/actions/business/core/banksAction';

import global from "../../../../../global.scss";

const Data = {
  Bank: "",
  BankLogo: "",
  KeyIdentifier: ""
};

const BanksModal = ({
  open, 
  setOpen, 
  title,
  update,
  page, 
  rowsPerPage
}) => {
  const dispatch = useDispatch();
  const tenantId = useSelectedTenant();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(1);

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(1);
  }

  useEffect(() => {
    try {
      if(open){
        if(update.defaultMode === 1){
          // mode = 1 - create bank account type
          setMode(1);
        }else if(update.defaultMode === 2){
          // mode = 2 - edit bank account type
          setMode(2);
          setFormData({
            ...formData,
            Bank: update.bank || "",
            BankLogo: update.bank_logo || "",
            KeyIdentifier: update.key_identifier || "",
          })
        }else{
          toast.error("Invalid modal");
          handleClose();
        }
      } 
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // --------------- handle change ----------------
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  const handleSubmit = () => {
    if(mode === 1){
      // create bank account type
      let obj = {
        bank: formData.Bank || "",
        bank_logo: formData.BankLogo || "",
        key_identifier: formData.KeyIdentifier || "",
      };
      dispatch(CreateBankBIZcore(tenantId, obj, setLoading)).then(() => {
        dispatch(GetBanksBIZcore(tenantId, page+1, rowsPerPage, "", setLoading)).then(() => {
          handleClose();
        })
      });
    }else if(mode === 2){
      // update bank account types
      let obj = {
        bank: formData.Bank || "",
        bank_logo: formData.BankLogo || "",
        key_identifier: formData.KeyIdentifier || "",
      };
      dispatch(UpdateBankBIZcore(tenantId, update.id, obj, setLoading)).then(() => {
        dispatch(GetBanksBIZcore(tenantId, page+1, rowsPerPage, "", setLoading)).then(() => {
          handleClose();
        })
      });
    }else{
      toast.error("Invalid modal");
      handleClose();
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow"
        width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"}
            sx={{ padding: "15px"}}>
            <Typography variant='h6' sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>
            <Box 
              className="flexCenterSBRow"
              gap={"15px"}
              mb={"15px"}>
              <TextField 
                label="Bank"
                fullWidth
                name="Bank"
                value={formData.Bank}
                onChange={handleChange}
                inputProps={{ maxLength: 100 }}
                />
              <TextField 
                label="Key Identifier"
                fullWidth
                name="KeyIdentifier"
                value={formData.KeyIdentifier}
                onChange={handleChange}
                inputProps={{ maxLength: 512 }}
                />
            </Box>
            <Box 
              className="flexCenterSBRow"
              gap={"15px"}
              mb={"15px"}>
              <TextField 
                label="BankLogo"
                fullWidth
                name="BankLogo"
                value={formData.BankLogo}
                onChange={handleChange}
                inputProps={{ maxLength: 512 }}
                />
            </Box>
          </Box>
          <Divider
           sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }}/>
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px"}}>
            <Button variant='text'
              onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton 
              variant='contained'
              loading={loading}
              disabled={!(formData.Type !== "")}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default BanksModal;